module.exports = require("node:fs");